import { useEffect, useState, useRef } from 'react';
import Header from '../../components/Header/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Platforms from './components/Platforms';
import Pricing from './components/Pricing';
import Testimonials from './components/Testimonials';
import CallToAction from './components/CallToAction';
import Footer from './components/Footer';
import './Support.css';
import { useLocation } from 'react-router-dom';

const Support = () => {
  const location = useLocation();
  
  // State for platform modals
  const [activePlatformId, setActivePlatformId] = useState(null);
  
  // State for service modals
  const [activeServiceId, setActiveServiceId] = useState(null);
  
  // Refs for scrollable sections
  const servicesRef = useRef(null);
  const platformsRef = useRef(null);
  const pricingRef = useRef(null);
  
  // Handlers for platform modals
  const openPlatformModal = (platformId) => {
    setActivePlatformId(platformId);
  };
  
  const closePlatformModal = () => {
    setActivePlatformId(null);
  };
  
  // Handlers for service modals
  const openServiceModal = (serviceId) => {
    setActiveServiceId(serviceId);
  };
  
  const closeServiceModal = () => {
    setActiveServiceId(null);
  };

  // Scroll handler for direct navigation to sections
  useEffect(() => {
    // Scroll to the top when component mounts
    window.scrollTo(0, 0);
    
    // Check if there's a hash in the URL to scroll to a specific section
    if (location.hash) {
      const id = location.hash.substring(1);
      const element = document.getElementById(id);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
    
    // Update document title
    document.title = 'Support Services | Gravity Point Media';
  }, [location]);

  return (
    <div className="min-h-screen flex flex-col support-page">
      <Header />
      <main className="flex-1">
        <Hero />
        <section id="services" ref={servicesRef}>
          <Services 
            activeServiceId={activeServiceId}
            openServiceModal={openServiceModal}
            closeServiceModal={closeServiceModal}
          />
        </section>
        <section id="platforms" ref={platformsRef}>
          <Platforms 
            activePlatformId={activePlatformId}
            openPlatformModal={openPlatformModal}
            closePlatformModal={closePlatformModal}
          />
        </section>
        <section id="pricing" ref={pricingRef}>
          <Pricing />
        </section>
        <Testimonials />
        <CallToAction />
      </main>
      <Footer 
        openServiceModal={openServiceModal}
        openPlatformModal={openPlatformModal}
      />
    </div>
  );
};

export default Support;
